module.exports = __webpack_public_path__ + "img/karmine-banner.dce99edb.png";